module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_Badges_116x116_4-f41f0870ef97277f298e7855ee3f332c.png";